// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/cdafff335249ef1cfcc8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4b30ad3867d0f8eb583a","180":"c3750aa459123502b1fe","245":"b8c9d80d248e6952eed6","246":"d49cd2e50c81cee2d9dd","247":"3e44b49fe022a85e4c8a"}[chunkId] + ".chunk.js";
};